import { render } from "./ToggleSwitch.vue?vue&type=template&id=399a2f5b&scoped=true"
import script from "./ToggleSwitch.vue?vue&type=script&lang=js"
export * from "./ToggleSwitch.vue?vue&type=script&lang=js"

import "./ToggleSwitch.vue?vue&type=style&index=0&id=399a2f5b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-399a2f5b"]])

export default __exports__